import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { AuthApiService } from 'cve-auth';

export const deepLinkGuard: CanMatchFn = async (route: Route, segments: UrlSegment[]) => {
    const authApiService = inject(AuthApiService);
    const router = inject(Router);

    if (authApiService.isLogged()) {
        return true;
    } else {
        const path = segments.map((segment) => segment.path).join('/');
        const queryString = window.location.search; // Captura ?reporting_option directamente
        
        authApiService.redirectUrl = queryString ? `${path}${queryString}` : path;
        
        console.log('Redirect URL guardada:', authApiService.redirectUrl);
        console.log('Query params:', queryString);
        router.navigate(['/login']);
    }
    return false;
};
